import { message } from 'antd';
import { queryWorkflowTemplateInfo } from '@api/workflow';

import PageAdd from './PageAdd';

class Edit extends PageAdd {
  componentWillMount() {
    const { uuid } = this.props.routeParams;
    this.loadData(uuid);
  }

  loadData = uuid => {
    const context = this;
    queryWorkflowTemplateInfo(uuid).then(res => {
      if (res.statusCode === 200) {
        context.setState({ data: res.data });
      } else {
        message.error(res.message);
      }
    });
  };
}

export default Edit;



// WEBPACK FOOTER //
// ./src/components/boss/workflow/template/PageEdit.js